import { characterItems } from "./lianxi-block-data.js";
import type { ExerciseCharacter } from "./lianxi-xiezi.js";
import { fetchStrokeFile } from "./stroke-file.js";
import { promptOf, recordingsOf, said } from "./xiezi-parts.js";

/**
 * The characters of an Exercise's block, ready for the drill.
 *
 * `partials/lianxi/drill.html` names the characters on the block and gives
 * each its own item in the row, carrying its reading and its recordings. The
 * outlines are fetched one small file per character, and a character whose
 * file cannot be fetched is left out. `lianxi-start.ts` builds the Exercise
 * from what this answers.
 */

/**
 * The characters the block names, each with its outlines fetched, and the
 * reading and recordings its item in the row carries.
 */
export async function fetchCharacters(
  block: HTMLElement,
  fetching: typeof fetch,
): Promise<readonly ExerciseCharacter[]> {
  const characters = Array.from(said(block, "cbCharacters"));
  const url = said(block, "cbBishun");
  const itemOf = characterItems(block);
  const files = await Promise.all(
    characters.map((character) => fetchStrokeFile(url, character, fetching)),
  );

  return characters.flatMap((character, at) => {
    const strokes = files[at];
    const item = itemOf(character);

    return strokes === undefined
      ? []
      : [
          {
            character,
            strokes,
            prompt: promptOf(item),
            recordings: recordingsOf(item),
          },
        ];
  });
}
